export default __webpack_public_path__ + "static/media/contact.ce8ba738.svg";